<mat-stepper orientation="horizontal"> <mat-step>
<ng-template matStepLabel>Chouse</ng-template> <ng-template
	matStepContent>
<div class="column">
	<div class="row">
		<div class="column">
			<div class="row">
				<div class="col m4">
					<p>Chouse avatar from galery or make new</p>
				</div>
			</div>
		</div>
		<div class="column">
			<div class="row">
				<div class="col m4">
				
					<button
						class="btn waves-effect waves-light indigo lighten-2 text-lighten-4">DRAWS
						[future]</button>
				</div>
			</div>
		</div>
		<div class="column">
			<div class="row">

				<div class="col m4">
					<input class="btn waves-effect waves-light upload" type="file"
						(change)="fileChangeEvent($event)" />
				</div>
			</div>
		</div>


		<div class="column">
			<div class="row">

				<div class="col m4">
					<button class="rt" mat-button matStepperNext>Next</button>
				</div>
			</div>
		</div>
	</div>
</div>
</ng-template></mat-step> <mat-step> <ng-template matStepLabel>Avatar</ng-template> <ng-template
	matStepContent>
<div class="row">
	<div class="column">
		<div class="row">
			<div class="column">
				<p>Make avatar</p>
			</div>
			<div class="column">
				<div class="mat-slider-container">
					<mat-slider style="width: 100%;" min="-147" max="147" step="0.07">
					<input matSliderThumb value="0"> </mat-slider>
				</div>
			</div>
		</div>
	</div>
	<div class="column">
		<div class="row l">
			<div class="col l9">
				<div class="img-cropper">
					<image-cropper [imageChangedEvent]="pageChangedEvent"
						[maintainAspectRatio]="false" format="png" [cropperMinWidth]="400"
						[cropperMinHeight]="400" (imageCropped)="pageCropped($event)"
						(imageLoaded)="pageLoaded($event)"
						(cropperReady)="pageCropperReady()"
						(loadImageFailed)="loadImageFailed()" (canvasRotation)="rotation"></image-cropper>
				</div>
			</div>
			<div class="col l3">
				<div class="row lc">
					<div class="col l12 s9">
						<div class="row">
							<div class="column">
								<div class="cropped-image">
									<img [src]="croppedpage" />
								</div>
							</div>
						</div>
					</div>
					<div class="col l12 s3">
						<div class="row">
							<button class="rt" mat-button matStepperPrevious>Back</button>
							<button class="rt" mat-button matStepperNext>Next</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</ng-template> </mat-step> <mat-step> <ng-template matStepLabel>Round</ng-template> <ng-template
	matStepContent>
<div class="row">
	<div class="column">
		<div class="row">
			<div class="col s12">
				<p>Make littel avatar</p>
			</div>
			<div class="column">
				<div class="mat-slider-container">
					<mat-slider style="width: 100%;" min="-147" max="147" step="0.07">
					<input matSliderThumb value="0"> </mat-slider>
				</div>
			</div>
		</div>
	</div>
	<div class="column">
		<div class="row l">
			<div class="col l9">
				<div class="img-cropper">
					<image-cropper style="max-height: 100%;"
						[imageChangedEvent]="profileChangedEvent"
						[maintainAspectRatio]="true" format="png" [aspectRatio]="1 / 1"
						[roundCropper]="true" [cropperMinWidth]="190"
						[cropperMinHeight]="190" (imageCropped)="thumbCropped($event)"
						(imageLoaded)="thumbLoaded()" (cropperReady)="thumbCropperReady()"
						(loadImageFailed)="loadImageFailed()" (canvasRotation)="rotation"></image-cropper>
				</div>
			</div>
			<div class="col l3">
				<div class="row lc">
					<div class="col l12 s9">
						<div class="round-cropped-image">
							<img [src]="croppedprofile" />
						</div>
					</div>
					<div class="col l12 s3">
						<div class="row  crt">
							<button class="rt" mat-button matStepperPrevious>Back&nbsp;</button>
							<button class="rt" mat-button (click)="onSubmit()">Make</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</ng-template></mat-step></mat-stepper>